import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatSeconds } from '../utils/areasFormat';
import { BODY_WEIGHT, FONT_SIZE, MUTED_TEXT } from '../agendaStyles';

type AgendaSlotHeaderProps = {
  startSeconds: number;
  sessionCount: number;
  orderCount: number;
  persons: number;
  timeFormat: string;
};

/** Sticky header of one start slot. The group wrapper in AgendaList carries the slot data attribute, not this. */
export const AgendaSlotHeader = ({
  startSeconds,
  sessionCount,
  orderCount,
  persons,
  timeFormat,
}: AgendaSlotHeaderProps) => {
  const { t } = useTranslation();
  const parts = [
    ...(sessionCount > 0 ? [t('calendar.areas_view.sessions_count', { count: sessionCount })] : []),
    ...(orderCount > 0 ? [t('calendar.areas_view.orders_count', { count: orderCount })] : []),
    t('calendar.areas_view.persons_count', { count: persons }),
  ];
  return (
    <Grid
      container
      alignItems="center"
      gap={1.5}
      wrap="nowrap"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: 'background.default',
        paddingBlock: 0.5,
        // The card's inline padding plus its 1px border, so the header's text lines up with the card's content.
        paddingInline: { xs: 'calc(14px + 1px)', md: 'calc(20px + 1px)' },
      }}>
      <Typography
        component="span"
        dir="ltr"
        sx={{
          bgcolor: 'primary.light',
          color: 'primary.main',
          fontSize: 17,
          fontWeight: 700,
          borderRadius: '4px',
          px: 1.25,
          py: 0.375,
          fontVariantNumeric: 'tabular-nums',
        }}>
        {formatSeconds(startSeconds, timeFormat)}
      </Typography>
      <Grid sx={{ flexGrow: 1, height: '1px', backgroundColor: 'divider' }} />
      <Typography sx={{ fontSize: FONT_SIZE.detail, fontWeight: BODY_WEIGHT, color: MUTED_TEXT, whiteSpace: 'nowrap' }}>
        {parts.join(' · ')}
      </Typography>
    </Grid>
  );
};
